module.exports = __webpack_public_path__ + "img/apple-app-store-mobile.c6772ef9.png";